var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"split-box bg-white p-4 shadow-theme rounded-small",style:(_vm.boxStyle)},[_vm._t("top-content"),(_vm.$scopedSlots['bottom-content'])?_c('div',{staticClass:"line my-4",class:{'has-bg-img': !!_vm.appBgImg},style:(_vm.lineStyle)}):_vm._e(),_vm._t("bottom-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }